import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import ColorsContext from './ColorsContext';
import { getDefaultDate, setLongmonyr } from './routines';
import RegionHeader from './RegionHeader';
import ISLTable from './ISLTable'; 

function PcpnStation(props) {
	const areaType = props.areaType;
	const monyr = props.date ? props.date : getDefaultDate();
	const [ stationData, setStationData ] = useState(null);
	const { levelColors } = useContext(ColorsContext);
	const monthSpiList = ["1-month", "2-month", "3-month", "6-month", "9-month", "12-month", "24-month", "36-month"];
	const daySpiList = ["30-day", "60-day", "90-day", "180-day", "270-day", "365-day", "730-day", "1095-day"];

	const dataFileNameBase = areaType === "region" ? "station_precip" : `station_${areaType}_precip`;
	const dataFileName = (props.match ? "." : ".") + "/data/" + dataFileNameBase + "_" + monyr + ".json";
	const spiList = monyr.length <= 7 ? monthSpiList : daySpiList;
	const buttontext = "Map View";
	const buttonValue = monyr.length === 7 ? (areaType === 'region' ? "pcpnregion" : `pcpn${areaType}`) : (areaType === 'region' ? "pcpnwkregion" : `pcpnwk${areaType}`);

	const longmonyr = setLongmonyr(monyr);

	const droughtRegions = [
		"Western",
		"Connecticut River",
		"Central",
		"Northeast",
		"Southeast",
		"Cape Cod",
		"Islands"
		];

		const basins = [
		"Blackstone",
		"Boston Harbor",
		"Buzzards Bay",
		"Cape Cod",
		"Charles",
		"Chicopee",
		"Connecticut",
		"Deerfield",
		"Farmington",
		"French",
		"Housatonic",
		"Hudson",
		"Ipswich",
		"Islands",
		"Merrimack",
		"Millers",
		"Narragansett Bay",
		"Nashua",
		"North Coastal",
		"Parker",
		"Quinebaug",
		"Shawsheen",
		"South Coastal",
		"SuAsCo",
		"Taunton",
		"Ten Mile",
		"Westfield"
		];
	
	const counties = [
		"Barnstable",
		"Berkshire",
		"Bristol",
		"Dukes",
		"Essex",
		"Franklin",
		"Hampden",
		"Hampshire",
		"Middlesex",
		"Nantucket",
		"Norfolk",
		"Plymouth",
		"Suffolk",
		"Worcester"
	];

	var droughtAreas;
	switch (areaType) {
		case 'region':
		droughtAreas = droughtRegions;
		break;
		case 'basin':
		droughtAreas = basins;
		break;
		case 'county':
		droughtAreas = counties;
		break;
		default:
		console.log(`Bad areaType selection - ${areaType}`);
		droughtAreas = droughtRegions;
	}

	const getStnData = () => {
		axios.get(dataFileName)
		.then(results => {
			setStationData(results.data.data);
		})
		.catch(err => {
			console.log("Station Data Error: " + err);
		});
	}

	useEffect(() => {
		getStnData();
		 // eslint-disable-next-line
	}, [])

	return (
		<>
			<RegionHeader
				title={"Precipitation"}
				buttontext={buttontext}
				buttonValue={buttonValue}
				handleButtonClick={props.handleButtonClick}
			/>
			{stationData &&
				<div className="pcpnTableContainer-container">
					<table className="pcpnTable-container">
						<caption>
							{longmonyr + " Standardized Precipitation Index Percentiles"}<br />
							<ISLTable />
						</caption>	  
						<thead>
							<tr>
								<th scope="col">{areaType[0].toUpperCase() + areaType.slice(1)}</th>
								<th scope="col">Station</th>
								<th scope="col">{spiList[0]}</th>
								<th scope="col">{spiList[1]}</th>
								<th scope="col">{spiList[2]}</th>
								<th scope="col">{spiList[3]}</th>
								<th scope="col">{spiList[4]}</th>
								<th scope="col">{spiList[5]}</th>
								<th scope="col">{spiList[6]}</th>
								<th scope="col">{spiList[7]}</th>
							</tr>
						</thead>
						<tbody className="stnTable-container">
							{droughtAreas.map((rd, i) => (						   
								<React.Fragment key={"f"+i}>
									{Object.keys(stationData[rd]).map((stn, j) => (
										<tr key={i+"stn"+j}>
											<td>{rd.replace("Connecticut River","CTRV")}</td>
											<td>{stationData[rd][stn].name}</td>
											{spiList.map((mon, j) => (
												<td key={i+"stn"+j+mon} style={{
													backgroundColor: stationData[rd][stn][mon] ? levelColors[stationData[rd][stn][mon].level] : "white",
													color: stationData[rd][stn][mon] && stationData[rd][stn][mon].level === 4 ? "white" : "black"
												}}>
													{stationData[rd][stn][mon] ? stationData[rd][stn][mon].pctl.toFixed(0) : "NA"}
												</td>
											))} 
										</tr>
									))}
								</React.Fragment>
							))}
						</tbody>
					</table>
				</div>
			}
		</>	
	);
}

export default PcpnStation;
